import { render, staticRenderFns } from "./FacilityBestPractices.vue?vue&type=template&id=313ffa77&scoped=true&"
import script from "./FacilityBestPractices.vue?vue&type=script&lang=js&"
export * from "./FacilityBestPractices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313ffa77",
  null
  
)

export default component.exports